import { useEffect, useContext, useState } from "react";
import { useFormik } from "formik";
import * as Icon from "react-bootstrap-icons";
import Context from "../../../../context";
import ManageAccountPageWrapper from "../../Layout/ManageAccountPageWrapper";
import PageSection from "../../Layout/PageSection";
import SelectItem from "../../Input/AccountSelectItem";
import Button from "../../Input/Button";
import PaymentMethodPageSection from "../../Layout/PaymentMethodPageSection";
import axios from "axios";
import { API_URL } from "../../../data/constants";

export default function ManageAccountAutoPayPage() {
  const { contextState, setContextState } = useContext(Context);
  const [selectedPayment, setSelectedPayment] = useState("");
  const [stateId, setStateId] = useState(0);
  const [callMessage, setCallMessage] = useState();
  const [isLoading, setIsLoading] = useState(true);
  let userRole = localStorage.getItem("userRole");

  useEffect(() => {
    setIsLoading(true);
    axios
        .get(API_URL + `/Accounts/${localStorage.getItem("username")}/${userRole}`, {
          headers: {
            Authorization: `${localStorage.getItem("accessToken")}`,
          },
        })
      .then((res) => {
        setContextState({ ...contextState, autoPayAccounts: res.data, autoPayAccountsChanged: false });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [contextState.autoPayAccountsChanged]);
  
  const autoPayForm = useFormik({
    initialValues: {
        selectedAccounts: []
    },
    onSubmit: (values) => {
      setCallMessage();
      let selectedAccounts = contextState.autoPayAccounts;
      values.billingAddressStateId = stateId;
      values.billingName =
        values.firstName + " " + values.middleInitial + " " + values.lastName;
      axios
        .post(
          API_URL + "/Payments/ToggleAutopay",
          {
            customers: selectedAccounts
              .filter((acct) => acct.isSelected === true)
              .map((acct) => {
                return {
                  customerId: acct?.customerId,
                  customerNumber: acct?.customerNumber,
                  masterCustomerId: acct?.masterCustomerId,
                };
              }),
          },
          {
            headers: {
              Authorization: `${localStorage.getItem("accessToken")}`,
            },
          }
        )
        .then((res) => {
          setCallMessage(res.data.message);
          setContextState({ ...contextState, autoPayAccountsChanged: true });
        })
        .catch((err) => console.error(err));
    },
  });

  return (
    <ManageAccountPageWrapper pageName="Setup Autopay">
      <form onSubmit={autoPayForm.handleSubmit}>
        {isLoading ? (
            <div className="d-flex justify-content-center align-items-center">
              <div className="spinner-border mr-4" role="status"/>
              <h4>Loading Accounts...</h4>
            </div>
        ) : (
        <PageSection sectionName="Select Accounts">
          <ul className="autopay-list">
            {contextState.autoPayAccounts &&
              contextState.autoPayAccounts.map((acct, index) => {
                return (
                  <SelectItem
                    key={index}
                    rowAlign={"reverse"}
                    form={autoPayForm}
                    account={acct}
                    value={autoPayForm.companies}
                    defaultChecked>
                    <span>
                      {acct.autoPay ? (
                        <div className="autopay--true">
                          Autopay Setup{" "}
                          <Icon.Check2Circle height={20} width={20} />
                        </div>
                      ) : (
                        <div className="autopay--false">
                          No Autopay Setup
                          <Icon.X height={24} width={24} />
                        </div>
                      )}
                    </span>
                  </SelectItem>
                );
              })}
          </ul>
            {callMessage && <p>{callMessage}</p>}
            <Button
                className="btn btn--green btn--bordered"
                text="Save Autopay"
                type="submit"
                disabled={selectedPayment === undefined ||
                    !selectedPayment
                }
            />
          <p className="page-section-warning">
            The new autopay will replace the existing autopay.
          </p>
        </PageSection>
        )}
        <PaymentMethodPageSection
          form={autoPayForm}
          title="Payment Methods"
          hasExisting
          paymentView="existing"
          noOptions
          isGlobal
          setSelectedMethod={setSelectedPayment}
        />
        <p className="page-section-warning autopay-page-section-warning">
          NOTE: the payment will be processed on the due date listed on the
          invoice.
        </p>
      </form>
    </ManageAccountPageWrapper>
  );
}
